<template>
  <div class="app-container">
    <!-- 主容器 -->
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <!-- 搜索表单 -->
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="100px">
          <!-- 搜索条件行 -->
          <el-row :gutter="24" type="flex" justify="right">
            <!-- 客户名称搜索 -->
            <el-col :span="4">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" clearable @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <!-- 确认状态搜索 -->
            <el-col :span="5">
              <el-form-item label="确认状态" prop="confirmStatus">
                <el-select v-model="queryParams.confirmStatus" placeholder="请选择" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="未确认" value="0"></el-option>
                  <el-option label="已确认" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 确认状态搜索 -->
            <el-col :span="5">
              <el-form-item label="收款状态" prop="receiptStatus">
                <el-select v-model="queryParams.receiptStatus" placeholder="请选择" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="未收款" value="0"></el-option>
                  <el-option label="已收款" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 使用单位搜索 -->
            <el-col :span="5">
              <el-form-item label="使用单位" prop="usingUnit">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <!-- 检测时间搜索 -->
            <el-col :span="5">
              <el-form-item label="检测时间" prop="testDateRange">
                <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%;"
                                @change="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="5">
              <el-form-item label="收款时间" prop="receiptTimeRange">
                <el-date-picker v-model="queryParams.receiptTimeRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 功能按钮区域 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleQuery" @handleConfirm="handleConfirm" @exportToExcel="exportToExcel" />
          </div>

          <!-- 数据表格 -->
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                    @selection-change="handleSelectionChange" :cell-style="setCellStyle" height="520">
            <!-- 多选框列 -->
            <el-table-column type="selection" width="55" align="left"></el-table-column>
            <!-- 序号列 -->
            <el-table-column label="序号" align="left" type="index" width="50" show-overflow-tooltip></el-table-column>
            <!-- 提示信息 -->
            <el-table-column label="提示信息" align="left" prop="rebateFee" :min-width="tipInfoColMinWidth" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ getTipInfoText(scope.row) }}
              </template>
            </el-table-column>
            <!-- 识别码列 -->
            <el-table-column label="识别码" align="left" prop="OIDNO" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 委托编号列 -->
            <el-table-column label="委托编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
            <!-- 层数/高度/长度列 -->
            <el-table-column label="层数/高度/长度" align="left" prop="ELEFLOORNUMBER" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 使用单位列 -->
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- 确认状态列 -->
            <el-table-column label="确认状态" align="left" prop="confirmStatus" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.confirmStatus === '1' ? '已确认' : '未确认' }}
              </template>
            </el-table-column>
            <!-- 收款时间 列 -->
            <el-table-column label="收款时间" align="left" prop="receiptTime" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 收款状态列 -->
            <el-table-column label="收款状态" align="left" prop="receiptStatus" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.receiptStatus === 1 ? '已收款' : scope.row.receiptStatus === 0 ? '已撤销' : '未收款' }}
              </template>
            </el-table-column>
            <!-- 检测日期列 -->
            <el-table-column label="检测日期" align="left" prop="testEmployeeDate" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.testEmployeeDate ? scope.row.testEmployeeDate.split(' ')[0] : '' }}
              </template>
            </el-table-column>
            <!-- 客户名称列 -->
            <el-table-column label="客户名称" align="left" prop="compName" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- 应收款列 -->
            <el-table-column label="应收款" align="left" prop="receivable" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 已收款列 -->
            <el-table-column label="已收款" align="left" prop="paidAmount" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 返点方案列 -->
            <el-table-column label="返点方案" align="left" prop="rebateTypeStr" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 返点费用列 -->
            <el-table-column label="返点具体方案" align="left" prop="rebateInfo" min-width="180" show-overflow-tooltip></el-table-column>
            <!-- 返点费用列 -->
            <el-table-column label="返点费用" align="left" prop="rebateFee" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 居间人承担税率列 -->
            <el-table-column label="居间人承担税率" align="left" prop="brokerTaxRate" min-width="130" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.brokerTaxRate }}%
              </template>
            </el-table-column>
            <!-- 居间人承担税额列 -->
            <el-table-column label="居间人承担税额" align="left" prop="brokerTaxAmount" min-width="130" show-overflow-tooltip></el-table-column>
            <!-- 应付返点费用列 -->
            <el-table-column label="应付返点费用" align="left" prop="payableRebateFee" min-width="120" show-overflow-tooltip></el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" align="left" prop="operation" min-width="100" show-overflow-tooltip fixed="right">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleEdit="handleEdit(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[500, 1000]" :page-size="queryParams.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 修改返点费用弹窗组件 -->
    <EditRebateDialog ref="editRebateDialog" @refresh="getList" />
  </div>
</template>

<script>
// 导入API接口
import { queryRebateList, confirmRebate, exportRebate, checkRebateConfirmed } from '@/api/contract/contract'
// 导入修改返点费用弹窗组件
import EditRebateDialog from './EditRebateDialog.vue'
// 导入权限按钮组件
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'
import PermissionMethodRow from '@/components/button/PermissionMethodRow.vue'

export default {
  name: 'RebateCalculation',
  props: {
    // 页面URL，用于权限按钮组件
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    EditRebateDialog,
    PermissionMethodToolbar,
    PermissionMethodRow
  },
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 500,
        compNames: '',
        usingUnit: '',
        confirmStatus: '0',
        receiptStatus: '1',
        testDateRange: [],
        receiptTimeRange: []
      },
      // 选中的数据
      selectedRows: []
    };
  },
  created () {
    // 页面加载时查询列表
    this.getList()
  },
  computed: {
    // “提示信息”列：如果全是'--'（或无数据）就窄一些，否则给足空间
    tipInfoColMinWidth () {
      if (!Array.isArray(this.tableData) || this.tableData.length === 0) return 120
      const hasAnyTip = this.tableData.some(row => this.getTipInfoText(row) !== '--')
      return hasAnyTip ? 240 : 120
    }
  },
  methods: {
    getTipInfoText (row) {
      const testEmployeeDate = row?.testEmployeeDate
      const rebateFee = row?.rebateFee

      const noTestDate = testEmployeeDate === null || testEmployeeDate === undefined || String(testEmployeeDate).trim() === ''
      const noRebateFee = rebateFee === null || rebateFee === undefined || String(rebateFee).trim() === '' || rebateFee === 0 || rebateFee === '0'

      return (noTestDate && noRebateFee) ? '没有检测日期，返点费用没计算' : '--'
    },
    /**
     * 搜索按钮点击事件
     */
    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.getList()
    },

    /**
     * 查询列表数据
     */
    getList () {
      this.loading = true

      // 构建查询参数，只传有值的字段
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize || 500
      }

      // 如果客户名称有值，则添加到参数中
      if (this.queryParams.compNames) {
        params.compNames = this.queryParams.compNames
      }

      // 如果使用单位有值，则添加到参数中
      if (this.queryParams.usingUnit) {
        params.usingUnit = this.queryParams.usingUnit
      }

      // 如果确认状态有值，则添加到参数中
      if (this.queryParams.confirmStatus) {
        params.confirmStatus = this.queryParams.confirmStatus
      }

      // 如果收款状态有值，则添加到参数中
      if (this.queryParams.receiptStatus) {
        params.receiptStatus = this.queryParams.receiptStatus
      }

      // 如果检测时间有值，则添加到参数中
      if (this.queryParams.testDateRange) {
        params.testDateRange = this.queryParams.testDateRange
      }
      // 如果收款时间有值，则添加到参数中
      if (this.queryParams.receiptTimeRange) {
        params.receiptTimeRange = this.queryParams.receiptTimeRange
      }

      // 调用查询接口
      queryRebateList(params).then(res => {
        if (res.retCode === 'ok') {
          this.tableData = res.additionalData.records || res.additionalData.list || []
          this.queryParams.currPage = res.additionalData.current || this.queryParams.currPage
          this.queryParams.pageSize = res.additionalData.size || this.queryParams.pageSize
          this.total = res.additionalData.total
          this.loading = false
        } else {
          this.$message.error(res.retMsg)
          this.loading = false
        }
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败')
        this.loading = false
      })
    },

    /**
     * 多选框选中数据变化事件
     * @param {Array} selection - 选中的数据数组
     */
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },

    /**
     * 确认按钮点击事件
     * 批量确认返点费用
     */
    handleConfirm () {
      // 检查是否选择了数据
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }

      // 确认操作
      this.$confirm('确定要确认选中的返点费用吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建确认数据
        const confirmData = {
          rebateDetails: this.selectedRows,
          confirmUserId: this.$store.state.loginUser.userId || this.$store.state.loginUser.id || '',
          confirmUserName: this.$store.state.loginUser.userName || ''
        }

        // 调用确认接口
        confirmRebate(confirmData).then(res => {
          if (res.retCode === 'ok') {
            this.$message.success('确认成功')
            this.getList()
          } else {
            this.$message.error(res.retMsg || '确认失败')
          }
        }).catch(error => {
          console.error('确认失败:', error)
          this.$message.error('确认失败')
        })
      }).catch(() => {
        this.$message.info('已取消确认')
      })
    },

    /**
     * 修改按钮点击事件
     * @param {Object} row - 当前行数据
     */
    handleEdit (row) {
      // 先检查返点费是否已确认
      checkRebateConfirmed(row.entrustNum).then(res => {
        if (res.retCode === 'ok') {
          // 已确认，打开修改弹窗
          this.$refs.editRebateDialog.openDialog(row)
        } else {
          // 未确认，提示用户
          this.$message.warning(res.retMsg || '返点费未确认，请先进行确认操作')
        }
      }).catch(error => {
        console.error('检查返点确认状态失败:', error)
        this.$message.error('检查返点确认状态失败')
      })
    },

    /**
     * 导出按钮点击事件
     */
    exportToExcel () {
      this.$message.success('正在导出返点计算数据...')
      // 调用导出接口
      exportRebate(this.queryParams).then(response => {
        // 创建Blob对象
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接
        const link = document.createElement('a');
        link.href = url;
        link.download = '返点计算管理.xlsx';

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },

    // 表格单元格样式设置
    setCellStyle ({ row, column }) {
      // 判断条件：检测日期为空 且 返点费用为0
      const isEmptyTestDate = !row.testEmployeeDate || row.testEmployeeDate === '';
      const isRebateFeeZero = row.rebateFee === 0 || row.rebateFee === '0' || row.rebateFee === '';

      // 如果满足条件，设置文字颜色为红色
      if (isEmptyTestDate && isRebateFeeZero) {
        return { color: 'red' };
      }
      // 不满足条件则使用默认样式
      return {};
    },
  }
}
</script>

<style scoped>
/* 容器样式 */
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
